import { Button, HStack, Tooltip } from '@chakra-ui/react';
import React from 'react';
import ProfileDropdownMenu from '../../ProfileDropdownMenu';
import { primary, text } from '@/theme/colors/palettes';
import svgIcons from '@/assets/svg/icons';
import SvgIcon from '@/components/atoms/SvgIcon';
import ContentFeedIcon from '@/components/atoms/icons/ContentFeedIcon';
import { Link, useRouterState } from '@tanstack/react-router';
import NotificationsBell from '../../NotificationsBell';
import { employeeUserRoutes } from '@/constants/routes/app';
import { useAppStore } from '@/store/useAppStore';
import { hasUnacceptedNonContentPolicyDocument } from '@/utils/onboardingUtils';

interface Props {
  isTransparent: boolean;
}

const DefaultHeader = ({ isTransparent }: Props) => {
  const { hasUnacceptedLegalDocuments, legalAcceptanceStatuses } = useAppStore();

  const { pathname } = useRouterState({ select: (state) => state.resolvedLocation });

  const isOnboarding = pathname.includes('onboarding');
  const isTermsAndConditions = pathname.includes('terms');
  const isPrivacyPolicy = pathname.includes('privacy');
  const hasPendingEulaUpdate = hasUnacceptedNonContentPolicyDocument(legalAcceptanceStatuses);
  const shouldShowNavigation = !isOnboarding && !isTermsAndConditions && !isPrivacyPolicy && !hasPendingEulaUpdate;

  const isGrowthZone = pathname === '/user/growth-zone';
  const isFeed = pathname.startsWith('/explore');

  const notificationsColor = isTransparent ? 'white' : text.mediumBlue;
  const growthZoneColor = isGrowthZone ? primary['500'] : isTransparent ? 'white' : text.mediumBlue;
  const feedColor = isFeed ? primary['500'] : isTransparent ? 'white' : text.mediumBlue;

  return (
    <HStack gap={'10px'}>
      {shouldShowNavigation && (
        <Tooltip
          label="Explore"
          backgroundColor={'white'}
          borderRadius={'10px'}
          padding={'10px'}
          color={'text.mediumBlue'}
          top={-3}
        >
          <Button
            tabIndex={-1}
            as={Link}
            variant={'headerLinkButton'}
            backgroundColor={'transparent'}
            boxShadow={'none'}
            to={employeeUserRoutes.explore}
            paddingX={'10px'}
            leftIcon={
              <HStack alignItems={'center'}>
                <ContentFeedIcon size={28} viewBox="0 0 34 34" color={feedColor} />
              </HStack>
            }
          />
        </Tooltip>
      )}

      {shouldShowNavigation && (
        <Tooltip
          label="Growth Zone"
          backgroundColor={'white'}
          borderRadius={'10px'}
          padding={'10px'}
          color={'text.mediumBlue'}
          top={-3}
        >
          <Button
            tabIndex={-1}
            as={Link}
            variant={'headerLinkButton'}
            backgroundColor={'transparent'}
            boxShadow={'none'}
            color={growthZoneColor}
            to={employeeUserRoutes.growthZone}
            paddingX={'10px'}
            leftIcon={
              <HStack alignItems={'center'}>
                <SvgIcon
                  iconPath={svgIcons.flag}
                  size={24}
                  boxWidth={24}
                  strokeWidth={2.5}
                  strokeColor={growthZoneColor}
                  boxHeight={28}
                  color={'transparent'}
                />
              </HStack>
            }
          />
        </Tooltip>
      )}

      {!isOnboarding && !hasUnacceptedLegalDocuments && <NotificationsBell color={notificationsColor} />}

      <ProfileDropdownMenu isHeaderTransparent={isTransparent} />
    </HStack>
  );
};

export default DefaultHeader;
